module.exports = __webpack_public_path__ + "img/SYM01.76767dad.gif";